import React from "react";
import "./auth.css";
import Login from "./login";
import { Colors } from "../../Constants/colors";
import SchoolLogo from "./../../images/school-logo.png";
import { useMobile } from "../../hooks/deviceHooks/useDevice.hooks";
import {
  DISPLAY,
  FLEX_DIRECTION,
  ALIGN_ITEMS,
  JUSTIFY_CONTENT,
  SPACING,
  FONT_SIZE,
} from "../../Constants/Enums/styles.enum";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";

export enum FormType {
  LOGIN = "login",
  REGISTER = "register",
}

const AuthForm = () => {
  const isMobile = useMobile();

  return (
    <div
      className="h-screen w-screen flex"
      style={{
        backgroundColor: Colors.White,
        overflow: "hidden",
      }}
    >
      {/* Left Side - Branding & Illustration */}
      {!isMobile && (
        <div
          style={{
            width: "35%",
            height: "100%",
            background: `linear-gradient(135deg, ${Colors.CrimsonRed} 0%, ${Colors.TangerineOrange} 100%)`,
            display: DISPLAY.FLEX,
            flexDirection: FLEX_DIRECTION.COLUMN,
            justifyContent: JUSTIFY_CONTENT.CENTER,
            alignItems: ALIGN_ITEMS.CENTER,
            padding: SPACING.S48,
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Decorative Background Elements */}
          <div
            style={{
              position: "absolute",
              top: "-100px",
              right: "-100px",
              width: "400px",
              height: "400px",
              borderRadius: "50%",
              background: Colors.White,
              opacity: 0.05,
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "-150px",
              left: "-150px",
              width: "500px",
              height: "500px",
              borderRadius: "50%",
              background: Colors.White,
              opacity: 0.05,
            }}
          />

          {/* Logo Section */}
          <div
            style={{
              display: DISPLAY.FLEX,
              flexDirection: FLEX_DIRECTION.COLUMN,
              alignItems: ALIGN_ITEMS.CENTER,
              gap: SPACING.S40,
              zIndex: 1,
            }}
          >
            {/* School Name - More Prominent */}
            <div style={{ textAlign: "center" }}>
              <h1
                style={{
                  fontSize: FONT_SIZE.F36,
                  fontFamily: FontFamily.POPPINS_BOLD,
                  color: Colors.White,
                  marginBottom: SPACING.S8,
                  textShadow: "0 3px 6px rgba(0,0,0,0.2)",
                  letterSpacing: "1px",
                }}
              >
                ROSE MOUNT
              </h1>
              <h2
                style={{
                  fontSize: FONT_SIZE.F28,
                  fontFamily: FontFamily.POPPINS_REGULAR,
                  color: Colors.White,
                  marginBottom: SPACING.S24,
                  textShadow: "0 2px 4px rgba(0,0,0,0.15)",
                  letterSpacing: "2px",
                }}
              >
                PRE SCHOOL
              </h2>
            </div>

            {/* Logo - Improved Display */}
            <div
              style={{
                position: "relative",
                display: DISPLAY.FLEX,
                alignItems: ALIGN_ITEMS.CENTER,
                justifyContent: JUSTIFY_CONTENT.CENTER,
              }}
            >
              <div
                style={{
                  backgroundColor: `rgba(255, 255, 255, 0.95)`,
                  borderRadius: "50%",
                  padding: SPACING.S12,
                  boxShadow: "0 15px 50px rgba(0,0,0,0.3)",
                  width: "180px",
                  height: "180px",
                  display: DISPLAY.FLEX,
                  alignItems: ALIGN_ITEMS.CENTER,
                  justifyContent: JUSTIFY_CONTENT.CENTER,
                  border: `4px solid ${Colors.White}`,
                }}
              >
                <img
                  src={SchoolLogo}
                  alt="Rose Mount Pre School logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>

            {/* Tagline */}
            <div style={{ textAlign: "center" }}>
              <p
                style={{
                  fontSize: FONT_SIZE.F16,
                  fontFamily: FontFamily.ROBOTO_REGULAR,
                  color: Colors.White,
                  opacity: 0.95,
                  lineHeight: "1.6",
                  maxWidth: "320px",
                }}
              >
                Empowering education through innovative technology and
                streamlined academic management
              </p>
            </div>

            {/* Feature Highlights */}
            <div
              style={{
                display: DISPLAY.FLEX,
                flexDirection: FLEX_DIRECTION.COLUMN,
                gap: SPACING.S20,
                marginTop: SPACING.S32,
              }}
            >
              {[
                { icon: "✓", text: "Comprehensive Student Records" },
                { icon: "✓", text: "Real-Time Grade Management" },
                { icon: "✓", text: "Advanced Analytics Dashboard" },
                { icon: "✓", text: "Secure Data Protection" },
              ].map((feature, index) => (
                <div
                  key={index}
                  style={{
                    display: DISPLAY.FLEX,
                    alignItems: ALIGN_ITEMS.CENTER,
                    gap: SPACING.S16,
                  }}
                >
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      backgroundColor: Colors.White,
                      display: DISPLAY.FLEX,
                      alignItems: ALIGN_ITEMS.CENTER,
                      justifyContent: JUSTIFY_CONTENT.CENTER,
                      fontSize: FONT_SIZE.F16,
                      color: Colors.TangerineOrange,
                      fontFamily: FontFamily.POPPINS_BOLD,
                    }}
                  >
                    {feature.icon}
                  </div>
                  <span
                    style={{
                      fontSize: FONT_SIZE.F16,
                      fontFamily: FontFamily.ROBOTO_REGULAR,
                      color: Colors.White,
                    }}
                  >
                    {feature.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Right Side - Login Form */}
      <div
        style={{
          width: isMobile ? "100%" : "65%",
          height: "100%",
          backgroundColor: Colors.White,
          display: DISPLAY.FLEX,
          alignItems: ALIGN_ITEMS.CENTER,
          justifyContent: JUSTIFY_CONTENT.CENTER,
          padding: isMobile ? SPACING.S24 : SPACING.S48,
          overflowY: "auto",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "500px",
          }}
        >
          {/* Mobile Logo */}
          {isMobile && (
            <div
              style={{
                display: DISPLAY.FLEX,
                flexDirection: FLEX_DIRECTION.COLUMN,
                alignItems: ALIGN_ITEMS.CENTER,
                marginBottom: SPACING.S32,
                gap: SPACING.S16,
              }}
            >
              <div
                style={{
                  width: "100px",
                  height: "100px",
                  padding: SPACING.S16,
                  background: `linear-gradient(135deg, ${Colors.CrimsonRed}15 0%, ${Colors.TangerineOrange}15 100%)`,
                  borderRadius: "50%",
                  display: DISPLAY.FLEX,
                  alignItems: ALIGN_ITEMS.CENTER,
                  justifyContent: JUSTIFY_CONTENT.CENTER,
                }}
              >
                <img
                  src={SchoolLogo}
                  alt="Rose Mount Pre School logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div style={{ textAlign: "center" }}>
                <h2
                  style={{
                    fontSize: FONT_SIZE.F20,
                    fontFamily: FontFamily.POPPINS_BOLD,
                    color: Colors.CrimsonRed,
                    marginBottom: SPACING.S4,
                  }}
                >
                  ROSE MOUNT
                </h2>
                <p
                  style={{
                    fontSize: FONT_SIZE.F14,
                    fontFamily: FontFamily.POPPINS_REGULAR,
                    color: Colors.Grey,
                  }}
                >
                  PRE SCHOOL
                </p>
              </div>
            </div>
          )}

          <Login header="welcome" subHeader="test" />
        </div>
      </div>
    </div>
  );
};
export default AuthForm;
